import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/personApplications/task/page',
    method: 'post',
    data,
  })
}
export async function approval(data) {
  return request({
    url: '/personApplications/task/check',
    method: 'post',
    data
  })
}
export async function revoke(data) {
  return request({
    url: '/personApplications/revoke',
    method: 'post',
    data,
  })
}
export async function checkUpdateField(data) {
  return request({
    url: '/personApplications/canAmend',
    method: 'post',
    data
  })
}
export async function updateAmend(data) {
  return request({
    url: '/personApplications/amend',
    method: 'post',
    data
  })
}